import { render, staticRenderFns } from "./case-info-export.vue?vue&type=template&id=3d54a669&scoped=true"
import script from "./case-info-export.vue?vue&type=script&lang=ts"
export * from "./case-info-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54a669",
  null
  
)

export default component.exports